var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 522 473",
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h522v473H0V0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h522.84v473.184H0zM228.136 346.407l-1.34 71.194"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m228.136 346.407-1.34 71.194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m300.554 346.407 6.837 71.194"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m300.554 346.407 6.837 71.194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M269.78 195.958c1.119-7.388 8.06-29.776 6.716-44.328-1.343-14.552-12.314-35.82-14.777-42.984"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M269.78 195.958c1.119-7.388 8.06-29.776 6.716-44.328-1.343-14.552-12.314-35.82-14.777-42.984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M339.63 228.197c12.09-3.358 55.075-4.478 72.538-20.15 17.463-15.671 26.866-61.566 32.239-73.879"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M339.63 228.197c12.09-3.358 55.075-4.478 72.538-20.15 17.463-15.671 26.866-61.566 32.239-73.879"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M216.047 226.853c-17.462-4.477-81.043-8.73-104.774-26.863-23.731-18.135-31.345-68.286-37.614-81.943"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M216.047 226.853c-17.462-4.477-81.043-8.73-104.774-26.863-23.731-18.135-31.345-68.286-37.614-81.943"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M439.2 94.395c-.946 5.535-9.285 25.23-5.677 33.21 3.608 7.979 17.594 16.862 27.325 14.668 9.73-2.194 25.883-23.195 31.06-27.834"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64f3d5",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M439.2 94.395c-.946 5.535-9.285 25.23-5.677 33.21 3.608 7.979 17.594 16.862 27.325 14.668 9.73-2.194 25.883-23.195 31.06-27.834"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M93.065 80.634c-.763 5.142 2.248 23.38-4.578 30.855-6.825 7.473-25.904 15.914-36.375 13.988-10.471-1.925-22.043-21.286-26.451-25.544"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64f3d5",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M93.065 80.634c-.763 5.142 2.248 23.38-4.578 30.855-6.825 7.473-25.904 15.914-36.375 13.988-10.471-1.925-22.043-21.286-26.451-25.544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64f3d5",
    d: "m173.724 357.136 18.807-170.582h151.804l18.807 170.582z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64f3d5",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m173.724 357.136 18.807-170.582h151.804l18.807 170.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64f3d5",
    d: "M183.862 440.992c-8.048-6.223 18.326-27.035 27.344-32.675 9.017-5.64 18.714-7.389 26.762-1.165 8.048 6.224 30.543 32.867 21.525 38.508-9.017 5.64-67.583 1.556-75.63-4.668zM269.875 447.454c-9.015-4.715 13.302-29.831 21.191-36.966 7.89-7.135 17.13-10.558 26.144-5.843 9.015 4.714 35.833 26.997 27.944 34.132-7.89 7.135-66.265 13.392-75.28 8.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M140.922 77.684c-1.905-22.175 14.528-41.692 36.703-43.593l136.516-11.7a40.306 40.306 0 0 1 43.6 36.71l1.954 22.753c1.904 22.175-14.529 41.692-36.704 43.592l-136.515 11.7c-22.175 1.9-41.696-14.535-43.6-36.71z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64f3d5",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M140.922 77.684c-1.905-22.175 14.528-41.692 36.703-43.593l136.516-11.7a40.306 40.306 0 0 1 43.6 36.71l1.954 22.753c1.904 22.175-14.529 41.692-36.704 43.592l-136.515 11.7c-22.175 1.9-41.696-14.535-43.6-36.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434343",
    d: "M266.197 72.54c0-14.185 12.028-25.684 26.866-25.684 7.125 0 13.959 2.706 18.997 7.523 5.039 4.816 7.87 11.35 7.87 18.162 0 14.185-12.03 25.685-26.867 25.685-14.838 0-26.866-11.5-26.866-25.685z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64f3d5",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M266.197 72.54c0-14.185 12.028-25.684 26.866-25.684 7.125 0 13.959 2.706 18.997 7.523 5.039 4.816 7.87 11.35 7.87 18.162 0 14.185-12.03 25.685-26.867 25.685-14.838 0-26.866-11.5-26.866-25.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434343",
    d: "M182.325 82.96c0-14.185 12.029-25.684 26.867-25.684 7.125 0 13.958 2.706 18.997 7.523 5.038 4.816 7.869 11.35 7.869 18.162 0 14.185-12.029 25.685-26.866 25.685-14.838 0-26.867-11.5-26.867-25.685z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64f3d5",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M182.325 82.96c0-14.185 12.029-25.684 26.867-25.684 7.125 0 13.958 2.706 18.997 7.523 5.038 4.816 7.869 11.35 7.869 18.162 0 14.185-12.029 25.685-26.866 25.685-14.838 0-26.867-11.5-26.867-25.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m212.189 253.21 5.202-51.37h103.77l5.201 51.37z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m212.189 253.21 5.202-51.37h103.77l5.201 51.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M322.675 234.328a63.741 63.741 0 0 0-5.934-6.562c-.467-.448-.237-1.15-1.078-.875-1.41.462-.17.774-.77 1.48-1.175 1.38-2.823 2.674-3.872 4.076-.192.255.078.96-.5.778-4.057-1.274-3.862-3.766-5.083-5.702-1.967-3.119-3.112-6.275-4.174-9.418-.631-1.866-.237-3.786-1.92-5.598-.289-.31-.15.304-.264.613-.838 2.283-.938 2.273-1.639 4.57-.859 2.819-.688 2.835-1.48 5.66a838.579 838.579 0 0 0-3.8 13.962c-.31 1.184-.01 2.496-1.347 3.51-.774.587-2.053-1.263-2.596-1.955-.42-.534-3.406-5.6-3.702-6.066-1.219-1.919-1.333-1.913-2.48-3.835-1.061-1.778-.309-2.16-.781-2.024-3.03.864-3.872 2.56-5.67 3.875-.869.635-1.092 1.25-1.43 1.17-3.181-.743-3.212-2.654-4.28-4.035-.262-.339-.094-.904-.638-.668-6.547 2.851-7.712 7.254-10.862 11.014-1.19 1.42-2.446 2.829-3.432 4.282-.208.306-.063.9-.49.599-2.623-1.85-2.079-4.054-2.343-6.073-.686-5.244-.263-10.45-1.072-15.697-.406-2.631-1.2-5.275-1.326-7.897-.016-.331.665-.947-.165-.998-2.757-.169-2.718 1.776-3.79 2.733-3.807 3.397-5.678 7.196-7.237 10.966-.587 1.419-1.588 2.786-2.52 4.158-.145.214.144.62-.252.434-2.32-1.09-1.227-2.7-1.562-4.049-.151-.606.274-2.335-.341-1.817-2.073 1.745-3.135 3.696-4.642 5.555-.161.198-2.732 3.662-2.932 3.504-4.258-3.362-6.002-7.04-8.63-10.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "M322.675 234.328a63.741 63.741 0 0 0-5.934-6.562c-.467-.448-.237-1.15-1.078-.875-1.41.462-.17.774-.77 1.48-1.175 1.38-2.823 2.674-3.872 4.076-.192.255.078.96-.5.778-4.057-1.274-3.862-3.766-5.083-5.702-1.967-3.119-3.112-6.275-4.174-9.418-.631-1.866-.237-3.786-1.92-5.598-.289-.31-.15.304-.264.613-.838 2.283-.938 2.273-1.639 4.57-.859 2.819-.688 2.835-1.48 5.66a838.579 838.579 0 0 0-3.8 13.962c-.31 1.184-.01 2.496-1.347 3.51-.774.587-2.053-1.263-2.596-1.955-.42-.534-3.406-5.6-3.702-6.066-1.219-1.919-1.333-1.913-2.48-3.835-1.061-1.778-.309-2.16-.781-2.024-3.03.864-3.872 2.56-5.67 3.875-.869.635-1.092 1.25-1.43 1.17-3.181-.743-3.212-2.654-4.28-4.035-.262-.339-.094-.904-.638-.668-6.547 2.851-7.712 7.254-10.862 11.014-1.19 1.42-2.446 2.829-3.432 4.282-.208.306-.063.9-.49.599-2.623-1.85-2.079-4.054-2.343-6.073-.686-5.244-.263-10.45-1.072-15.697-.406-2.631-1.2-5.275-1.326-7.897-.016-.331.665-.947-.165-.998-2.757-.169-2.718 1.776-3.79 2.733-3.807 3.397-5.678 7.196-7.237 10.966-.587 1.419-1.588 2.786-2.52 4.158-.145.214.144.62-.252.434-2.32-1.09-1.227-2.7-1.562-4.049-.151-.606.274-2.335-.341-1.817-2.073 1.745-3.135 3.696-4.642 5.555-.161.198-2.732 3.662-2.932 3.504-4.258-3.362-6.002-7.04-8.63-10.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m212.189 253.21 5.202-51.37h103.77l5.201 51.37z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m212.189 253.21 5.202-51.37h103.77l5.201 51.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M207.3 279.081c0-5.244 4.364-9.496 9.747-9.496 2.586 0 5.065 1 6.893 2.782a9.373 9.373 0 0 1 2.855 6.714c0 5.245-4.364 9.496-9.748 9.496-5.383 0-9.748-4.251-9.748-9.496zM236.058 279.081c0-5.244 4.364-9.496 9.748-9.496 2.585 0 5.065 1 6.893 2.782a9.373 9.373 0 0 1 2.855 6.714c0 5.245-4.365 9.496-9.748 9.496-5.384 0-9.748-4.251-9.748-9.496z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRobot);
export default __webpack_public_path__ + "static/media/Blue-Robot.209270da75e555fceff0e4543d7f3bfe.svg";
export { ForwardRef as ReactComponent };